import sumBy from "lodash/sumBy";
import { Configuration, ConfigurationCallbackInput } from "../../types/customization/configuration";
import { Content } from "../../types/customization/content";
import { Template, TemplatePageDefinition } from "../../types/customization/template";
import { getCoverFilteredPages, getNoCoverDefinitions } from "./cover";
import { findMinMaxEditablePictures } from "./template";

export function buildCallbackInput(
  content: Content,
  templatePagesNoCoverDefinition?: TemplatePageDefinition[]
): ConfigurationCallbackInput {
  return {
    pagesCount: countPages(content, templatePagesNoCoverDefinition),
  };
}

export function countPages(
  content: Content,
  templatePagesNoCoverDefinition?: TemplatePageDefinition[]
): number {
  switch (content.templateType) {
    case "book": {
      const contentPages = templatePagesNoCoverDefinition
        ? getCoverFilteredPages(content.pages, templatePagesNoCoverDefinition)
        : content.pages;
      return contentPages.length;
    }
    case "mural":
      return content.pages.length;
    case "print":
      return sumBy(content.printQuantities, (printQuantity) => printQuantity.quantity);
    default: {
      const exhaustiveCheck: never = content;
      throw new Error(
        `Unsupported templateType ${(exhaustiveCheck as { templateType: string }).templateType}`
      );
    }
  }
}

export function maxPageReached(
  content: Content,
  configuration?: Configuration,
  templatePageDefinitions?: TemplatePageDefinition[]
): boolean {
  if (!configuration || !configuration.pages || !configuration.pages.max) {
    return false;
  }
  if (templatePageDefinitions) {
    const noCoverPageDefinitions = getNoCoverDefinitions(templatePageDefinitions);
    return countPages(content, noCoverPageDefinitions) >= configuration.pages.max;
  }
  return countPages(content) >= configuration.pages.max;
}

export function hasSelectableOption(
  configuration: Configuration | undefined,
  template?: Template
): boolean {
  if (
    !configuration ||
    !configuration.options ||
    (template && template.optionDefinitions.length === 0)
  ) {
    return false;
  }

  const templateOptionsTags = template?.optionDefinitions.map(
    (optionDefinition) => optionDefinition.optionTag
  );
  for (const option of configuration.options) {
    if (
      option.values.length > 1 &&
      (!templateOptionsTags || templateOptionsTags.includes(option.tag))
    ) {
      return true;
    }
  }
  return false;
}

const MIN_PICTURE_SLOTS_NEEDED = 6;
export function hasSelectionInPanel(template: Template): boolean {
  const minMax = findMinMaxEditablePictures(template.pageDefinitions);
  if (template.templateType === "book" || minMax.max > MIN_PICTURE_SLOTS_NEEDED) {
    return true;
  }
  return false;
}
